module.exports = __webpack_public_path__ + "img/9788952757227.22b615b0.jpg";